import { render, staticRenderFns } from "./availability-zone.vue?vue&type=template&id=e8a5981e&scoped=true&"
import script from "./availability-zone.vue?vue&type=script&lang=js&"
export * from "./availability-zone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a5981e",
  null
  
)

export default component.exports